/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

// Staff (#740): a Box's TicketOrders, to take Mas Camp cash for the HELD one.
export const GET_BOX_TICKET_ORDERS = gql`
  query GetBoxTicketOrders($boxId: ID!) {
    getBoxTicketOrders(boxId: $boxId) {
      ticketOrderId
      boxId
      feteId
      feteName
      feteStartsAt
      status
      releaseReason
      ticketAmount
      convenienceFee
      total
      currency
      paymentMode
      holdExpiresAt
      lines {
        tierId
        tierName
        quantity
        unitPrice
        originalUnitPrice
        lineTotal
        feePerTicket
        lineFee
      }
      tickets {
        ticketId
        tierId
        tierName
      }
      viewTicketsUrl
      createdAt
    }
  }
`;
